export function scriptsBuildId(htmlOrDoc) {
  const srcs =
    typeof htmlOrDoc === 'string'
      ? [...htmlOrDoc.matchAll(/<script[^>]+src="([^"]+)"/gi)].map((m) => m[1])
      : [...(htmlOrDoc?.querySelectorAll?.('script[src]') || [])].map((el) => el.getAttribute('src') || '');
  return srcs.filter((s) => String(s).includes('assets/')).sort().join(',');
}

export async function checkAppBuild({
  fetchImpl = fetch,
  loc = typeof window !== 'undefined' ? window.location : null,
  doc = typeof document !== 'undefined' ? document : null,
  store = typeof sessionStorage !== 'undefined' ? sessionStorage : null,
} = {}) {
  if (!loc || !doc) return false;
  const local = scriptsBuildId(doc);
  if (!local) return false;
  const res = await fetchImpl(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
  if (!res.ok) return false;
  const data = await res.json();
  if (!data?.build || data.build === local) return false;
  if (store?.getItem('bsr-build-reload') === data.build) return false;
  store?.setItem('bsr-build-reload', data.build);
  const url = new URL(loc.href);
  url.searchParams.set('_v', String(data.build).replace(/[^a-zA-Z0-9]/g, '').slice(-16));
  loc.replace(url.toString());
  return true;
}

export function startAppBuildCheck() {
  const run = () => {
    checkAppBuild().catch(() => {});
  };
  run();
  if (typeof document === 'undefined') return undefined;
  const onVis = () => {
    if (document.visibilityState === 'visible') run();
  };
  document.addEventListener('visibilitychange', onVis);
  const tick = setInterval(run, 5 * 60 * 1000);
  return () => {
    document.removeEventListener('visibilitychange', onVis);
    clearInterval(tick);
  };
}
